import { COMMAND_MODE_HOTKEY, FILTER_MODE_HOTKEY } from '../constants';

export function isCommandModeInput(value: string): boolean {
  return value.startsWith(COMMAND_MODE_HOTKEY);
}

export function getCommandModeQuery(value: string): string {
  if (!isCommandModeInput(value)) return '';
  return value.slice(COMMAND_MODE_HOTKEY.length).trim();
}

export function isFilterModeInput(value: string): boolean {
  return value.startsWith(FILTER_MODE_HOTKEY);
}

export function getFilterModeQuery(value: string): string {
  if (!isFilterModeInput(value)) return '';
  return value.slice(FILTER_MODE_HOTKEY.length).trim();
}
